import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { guestGuidesApi as n } from "@maat/api-main";
//#region src/travelGuides/useGuestGuidesBrowseQuery.ts
var r = (r = {}) => t({
	queryKey: e.guestBrowse(r),
	fetchPage: (e) => n.list({
		...r,
		page: e
	}),
	key: "guides"
});
//#endregion
export { r as useGuestGuidesBrowseQuery };
